import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styled from 'styled-components'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import Close from 'material-ui/svg-icons/navigation/close'

const FullScreen = styled(
  ({
    className,
    children,
    onClose,
  }) => {
    return (
      <div className={cx('full-screen', className)}>
        {children({
          renderCloseButton: () => (
            <FloatingActionButton
              zDepth={1}
              mini
              backgroundColor={'#ffffff'}
              iconStyle={{
                fill: '#000000',
              }}
              onClick={onClose}
            >
              <Close />
            </FloatingActionButton>
          )
        })}
      </div>
    )
  },
)`
  ${({ visible }) => ({
    display: visible ? 'block' : 'none',
    position: 'fixed',
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    backgroundColor: '#ffffff',
    zIndex: 2000,
  })}
`

FullScreen.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  onClose: PropTypes.func,
}
FullScreen.defaultProps = {
  className: '',
  children: null,
  onClose: () => {},
}

export default FullScreen



// WEBPACK FOOTER //
// ./src/components/wrappers/FullScreen.js